module.exports = __webpack_public_path__ + "static/ss1.20fc8ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss1.png
// module id = 1164
// module chunks = 112875127094159